import script from "./hierarchyView.vue?vue&type=script&lang=js"
export * from "./hierarchyView.vue?vue&type=script&lang=js"

import "./hierarchyView.vue?vue&type=style&index=0&id=2320cf9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2320cf9c"]])

export default __exports__